import { render, staticRenderFns } from "./ClinicInvoice.vue?vue&type=template&id=84673ea6"
import script from "./ClinicInvoice.vue?vue&type=script&lang=js"
export * from "./ClinicInvoice.vue?vue&type=script&lang=js"
import style0 from "./ClinicInvoice.vue?vue&type=style&index=0&id=84673ea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports